/**
 * A Pressable wrapping one line of `text-sm` shrink-wraps to roughly a 20pt box --
 * well under the 44pt iOS HIG minimum and the 48dp Material one. Text links can't
 * grow without disturbing the layout (the password show/hide toggles are clipped
 * by TextInput's fixed-height row), so they buy the target back with hitSlop.
 */
export const LINK_HIT_SLOP = { top: 12, bottom: 12, left: 8, right: 8 } as const;
